/**
 * CORE-1730 — сообщение из одних фирменных эмодзи показывается без пузыря.
 *
 * Правило ТЗ: один токен `:agape_N:` — картинка 72, два или три — по 48 с
 * интервалом 8 (и переносом на новую строку, если не влезают); четыре и
 * больше или любой непробельный текст рядом — обычный пузырь и эмодзи в
 * строке. Пробелы вокруг токенов текстом не считаются. Режим определяется
 * только текстом, поэтому у отправителя и получателя, после перезагрузки и в
 * истории он один и тот же. Без React и RN — проверяется в jest.
 *
 * Лимит передаёт вызывающий (`EMOJI_ONLY_MAX`): веб-чаты — всегда; нативный
 * раздел сообщений v9 (CORE-1792) зовёт без лимита и одиночную выбирает сам.
 */
import { reactionOf } from '../constants/brandReactions';
import { parseEmojiTokens } from './emojiTokens';

/** Сторона одиночной эмодзи, CSS px. */
export const EMOJI_ONLY_SOLO_SIZE = 72;
/** Сторона каждой эмодзи, когда их две или три. */
export const EMOJI_ONLY_GROUP_SIZE = 48;
/** Интервал между эмодзи, по горизонтали и между строками. */
export const EMOJI_ONLY_GROUP_GAP = 8;
/** Больше стольких эмодзи — обычный пузырь (ТЗ: без пузыря 1–3). */
export const EMOJI_ONLY_MAX = 3;

/**
 * Слаги эмодзи, если текст — только токены комплекта и пробелы, и их не
 * больше `max` (когда он задан); иначе null — сообщение рисуется обычным
 * пузырём.
 */
export function emojiOnlyTokens(text: string | null | undefined, max?: number): string[] | null {
  if (!text) return null;
  const types: string[] = [];
  for (const seg of parseEmojiTokens(text)) {
    if (seg.type === 'emoji') {
      types.push(seg.reaction);
    } else if (seg.value.trim() !== '') {
      return null;
    }
  }
  if (types.length === 0) return null;
  return max != null && types.length > max ? null : types;
}

/** Сторона картинки по числу эмодзи в сообщении. */
export function emojiOnlySize(count: number): number {
  return count === 1 ? EMOJI_ONLY_SOLO_SIZE : EMOJI_ONLY_GROUP_SIZE;
}

/** Подпись доступности: русские названия эмодзи через запятую. */
export function emojiOnlyLabel(types: readonly string[]): string {
  return types.map((type) => reactionOf(type)?.label ?? type).join(', ');
}
